import { render, staticRenderFns } from "./CandidateSidebarHistoryTab.html?vue&type=template&id=d06533ba&scoped=true&external"
import script from "./CandidateSidebarHistoryTab.js?vue&type=script&lang=js&external"
export * from "./CandidateSidebarHistoryTab.js?vue&type=script&lang=js&external"
import style0 from "./CandidateSidebarHistoryTab.scss?vue&type=style&index=0&id=d06533ba&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06533ba",
  null
  
)

export default component.exports